import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-navigation-card',
  templateUrl: './navigation-card.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslocoModule, MatIconModule],
  styleUrls: ['./navigation-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationCardComponent {
  #router = inject(Router);

  /**
   * Navigate to dashboard
   */
  toDashboard() {
    this.#router.navigate(['/scenarios/manage']);
  }

  /**
   * Navigate to scenario browse
   */
  toSceneBrowse() {
    this.#router.navigate(['/scenarios/browse']);
  }

  /**
   * Navigate to documentation
   */
  toDocumentation() {
    // TODO : Empty until documentation exists
  }
}
